/*
 * @Description: 
 * @Author: code-shan
 * @Date: 2022-08-11 13:44:06
 * @LastEditTime: 2023-05-08 09:53:30
 * @LastEditors: code-shan
 * @FilePath: \truck-overall-planning\src\utils\domUtil.js
 */
/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-06-11 11:08:34
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-11 13:49:00
 */
export const setDocumentTitle = function (title) {
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

export const domTitle = '车辆互助出单定损系统'



// WEBPACK FOOTER //
// ./src/utils/domUtil.js